
<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">
      <div class="page-header">
        <div class="add-item d-flex">
          <div class="page-title">
            <h4>Chat Groups</h4>
          </div>
        </div>


      </div>
      <!-- SPLASH SCREEN TABLE -->
      <filter-table
          :extra-class="['table', 'datanew']"
          :columns="chatGroup.columns"
          :data="chatGroup.data.value"
          :filters="chatGroup.filters"
      >
        <template #header>
          <h4>Chat Groups</h4>
        </template>


        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'thumbnail'">
            <div class="">
              <a href="javascript:void(0);" class="">
                <Avatar
                    :src="record.thumbnail"
                    :alt="record.title"
                    :shape="shape"
                    img-class="user-image"
                />
              </a>

            </div>
          </template>



          <template v-if="column.key === 'action'">
            <td class="action-table-data">
              <div class="edit-delete-action">
<!--                <a @click="openModal('update', record.id)" class="me-2 p-2 mb-0">-->
<!--                  <i data-feather="edit" class="feather-edit"></i>-->
<!--                </a>-->
                <a
                    @click="deleteChatGroup(record.id)"
                    class="me-2 confirm-text p-2 mb-0"
                    href="javascript:void(0);"
                >
                  <i data-feather="trash-2" class="feather-trash-2"></i>
                </a>
              </div>
            </td>
          </template>
        </template>

        <!-- </template> -->
      </filter-table>
      <!-- SPLASH SCREEN TABLE -->
    </div>
  </div>

</template>

<script setup>

import {useChatGroupStore} from "@/store/chatGroupStore";
import Avatar from "@/components/avatar.vue";
import {computed, onMounted} from "vue";
import {confirm} from "@/utils/swal";

const chatGroupStore = useChatGroupStore();

const chatGroup = {
  filters: ["name", "privacy"],
  columns: [
    {
      title: "Group thumbnail",
      dataIndex: "thumbnail",
      key: "thumbnail",
    },
    {
      title: "Group Name",
      dataIndex: "name",
      key: "name",
      sorter: {
        compare: (a, b) => {
          a = a.name.toLowerCase();
          b = b.name.toLowerCase();
          return a > b ? -1 : b > a ? 1 : 0;
        },
      },
    },
    {
      title: "Group Privacy",
      dataIndex: "privacy",
      key: "privacy",
      sorter: {
        compare: (a, b) => {
          a = a.privacy.toLowerCase();
          b = b.privacy.toLowerCase();
          return a > b ? -1 : b > a ? 1 : 0;
        },
      },
    },

    {
      title: "Members ",
      dataIndex: "members_count",
      key: "members_count",
      sorter: {
        compare: (a, b) => {
          a = a.members_count.toLowerCase();
          b = b.members_count.toLowerCase();
          return a > b ? -1 : b > a ? 1 : 0;
        },
      },
    },

    {
      title: "Action",
      key: "action",
      sorter: true,
    },
  ],
  data: computed(() => chatGroupStore.chatGroup),
};


async function deleteChatGroup(id) {
  confirm({
    title: "Are you sure about this?",
    message: "This chat group will be deleted",
    callback: async (continueDelete) => {
      if (continueDelete) {
        await chatGroupStore.deleteChatGroup(id);
      }
    },
  });
}

onMounted(async () => {
  await chatGroupStore.fetchChatGroups();
});

</script>

<style scoped>

</style>